import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
var FILTER_DELIM = '-delim-';

export interface AvailableCustomerOperationsPageOptions extends PageOptionsBase {
    urlList: string;
    urlCustomerDetail: string;
    urlCustomerOperationDetail: string;
    urlAssignOperation: string;
    localizer: {
        StatusActive: string;
        StatusInactive: string;
        StatusInvalid: string;
        StatusRemoved: string;
    }
}

var COLUMNS_INDEX = {
    Customer: 0,
    CustomerCode: 1,
    OperationName: 2,
    OperationCode: 3,
    OperationStatus: 4
}

export class AvailableCustomerOperationsPage extends PageBase<AvailableCustomerOperationsPageOptions> {

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;
    private _formId: string;
    private _btnCancelSearchId: string;
    private _form: JQuery;
    private _btnCancelSearch: JQuery;
    private _filterCustomerCode: JQuery;
    private _filterOperationName: JQuery;
    private _filterOperationCode: JQuery;
    private _filterCustomer: MultiSelectApi;

    constructor(options: AvailableCustomerOperationsPageOptions) {
        super(options);

        var getCustomerDetailUrl = (rowData: any): string => (`${options.urlCustomerDetail}/${rowData.CustomerId}`);
        var getOperationDetailUrl = (rowData: any): string => (`${options.urlCustomerOperationDetail}/${rowData.OperationId}`);
        var getAssignOperationUrl = (rowData: any): string => (`${options.urlAssignOperation}&customerOperationId=${rowData.OperationId}`);

        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this._tableId = "tableAvailableCustomerOperations";
        this._formId = "formAvailableCustomerOperations";
        this._btnCancelSearchId = "btnCancelSearch";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'OperationId',
            autoWidth: true,
            columns: [
                {
                    data: 'CustomerName',
                    render: (data: any, type: any, rowData: any) => {
                        return (`<a href='${getCustomerDetailUrl(rowData)}'>${data}</a>`);
                    }
                },
                {
                    data: "CustomerCode",
                },
                {
                    data: "OperationName",
                    render: (data: any, type: any, rowData: any) => {
                        return (`<a href='${getOperationDetailUrl(rowData)}'>${data}</a>`);
                    }
                },
                {
                    data: "OperationCode",
                },
                {
                    data: "OperationStatus",
                },
                {
                    orderable: false,
                    searchable: false,
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<a class="assignOperationLink" data-operationId="${rowData.OperationId}" data-operationName="${rowData.OperationName}" data-customerId="${rowData.CustomerId}" data-customerName="${rowData.CustomerName}" href=${getAssignOperationUrl(rowData)}>Assign</a>`);
                    }
                },
            ],
            callbacks: {
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        this._form = Utils.getJQueryById(this._formId);
        this._btnCancelSearch = Utils.getJQueryById(this._btnCancelSearchId);

        this._filterCustomerCode = Utils.getJQueryById('filterCustomerCode');
        this._filterOperationName = Utils.getJQueryById('filterOperationName');
        this._filterOperationCode = Utils.getJQueryById('filterOperationCode');
        this._filterCustomer = new MultiSelectApi('filterCustomer');

        this._table = new Datatable(this._tableId, this._tableOptions);
        this._form.on('submit', this.formSubmit);
        this._btnCancelSearch.on('click', this.cancelSearch);

        let that = this;
        var confirmButton = <HTMLButtonElement>document.getElementById("btnConfirm");
        var closeButton = <HTMLButtonElement>document.getElementById("btnHideConfirmation");
        let assignOperationLink: string;
        $(document).on('click', '.assignOperationLink', function (e) {
            let operationNameAndId = e.target.attributes['data-operationName'].value + ' (' + e.target.attributes['data-operationId'].value + ')';
            let customerNameAndId = e.target.attributes['data-customerName'].value + ' (' + e.target.attributes['data-customerId'].value + ')';
            $("#operation-name-confirmation").text(operationNameAndId);
            $("#customer-name-confirmation").text(customerNameAndId);
            assignOperationLink = e.target.attributes['href'].value;
            that.assignOperation(e);
        });

        confirmButton.onclick = () => {
            window.location.href = assignOperationLink;
        };

        closeButton.onclick = () => this.closeDialog();
    }

    public assignOperation(e: any): void {
        e.preventDefault();
        this.openDialog();
    }

    private openDialog() {
        document.getElementById("areYouSureConfirmation").hidden = false;
    }
    private closeDialog() {
        document.getElementById("areYouSureConfirmation").hidden = true;
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterCustomerCode.val('');
        this._filterOperationName.val('');
        this._filterOperationCode.val('');
        this._filterCustomer.selectAll();
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterCustomerCode = this._filterCustomerCode.val();
        datatable.columns(COLUMNS_INDEX.CustomerCode).search(filterCustomerCode);

        var filterOperationName = this._filterOperationName.val();
        datatable.columns(COLUMNS_INDEX.OperationName).search(filterOperationName);

        var filterOperationCode = this._filterOperationCode.val();
        datatable.columns(COLUMNS_INDEX.OperationCode).search(filterOperationCode);

        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Customer).search(filterCustomer);
    }
}



/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/AvailableCustomerOperationsPage.ts
 **/